import React, { useState } from 'react';
import { Modal } from '@pella/sash-framework';
import RTASimpleForm from '../../common/forms/rta-simple-form';
import CTA from '../../common/cta';

import './index.css';

const RTAPopout = () => {
	const [slideIn, setSlideIn] = useState(false);
	const onModalTrigger = () => setSlideIn(!slideIn);

	return (
		<>
			<CTA
				data={{
					gtm_link_type: 'button',
					button_style: 'secondary',
				}}
				id='js-rtaPopout'
				onClick={onModalTrigger}
				className='fixed right-0 top-1/4 !w-auto origin-bottom-right -rotate-90 py-2 !text-base normal-case tracking-wide hover:!opacity-90 md:!text-lg'
				style={{ display: 'none' }}
			>
				<span>Free Quote</span>
			</CTA>

			<Modal
				isOpen={slideIn}
				onClose={onModalTrigger}
			>
				<Modal.Content>
					<RTASimpleForm className='border-0 !p-0 shadow-none [&_label]:pointer-events-none' />
				</Modal.Content>
			</Modal>
		</>
	);
};

export default RTAPopout;
